import {Component, OnInit} from '@angular/core';
import {User} from '../../models/user.model';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {

  public credentials = {
    email: '',
    password: '',
  };

  public errors: any = {};

  constructor(private router: Router,
              private authService: AuthService) {
  }

  ngOnInit() {
  }

  onSubmit() {
    this.authService.login(this.credentials.email, this.credentials.password)
      .subscribe(
        response => {
          User.setToLS(new User({...response.user, token: response.api_token}));
          console.log(User.getFromLS());
          const redirect = this.authService.redirectOnLogin === null ? User.defaultRedirectTo() : this.authService.redirectOnLogin;

          console.log(redirect);
          return this.router.navigate(redirect);
        },
        errors => {
          this.errors = errors;
        }
      );
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/login/login.component.ts